import {useQuery} from '@tanstack/react-query'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {useAccessToken, useUsid} from '@salesforce/commerce-sdk-react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {parseGeoString} from '../utils/custom-utils'
import {getClinetIP} from '../utils/custom-api-utils'

const useCustomShopperContext = () => {
    const appOrigin = useAppOrigin()
    const {getTokenWhenReady} = useAccessToken()
    const config = getConfig()
    const {usid} = useUsid()

    const {data: ip} = useQuery({
        queryKey: ['client-ip'],
        queryFn: async () => {
            const result = await getClinetIP(appOrigin)
            return result?.ip
        },
        staleTime: 60 * 60 * 1000, // 1 hour
        cacheTime: 2 * 60 * 60 * 1000 // 2 hours
    })

    const {data: shopperContext} = useQuery({
        queryKey: ['custom-shopper-context', ip, usid],
        queryFn: async () => {
            try {
                const token = await getTokenWhenReady()
                const orgId = config?.app?.commerceAPI?.parameters?.organizationId
                const siteId = config?.app?.commerceAPI?.parameters?.siteId
                const clientIp = {clientIp: ip}
                const sourceCode =
                    typeof window !== 'undefined' && localStorage.getItem('sourceCode')
                if (sourceCode) {
                    clientIp.sourceCode = sourceCode
                }
                const apiUrl = `${appOrigin}/mobify/proxy/api/shopper/shopper-context/v1/organizations/${orgId}/shopper-context/${usid}?siteId=${siteId}`
                const response = await fetch(apiUrl, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify(clientIp)
                })

                const geoHeader =
                    response.headers.get('x-geolocation') ||
                    'CountryCode: IN; Country: India; City: Kalaburagi; PostalCode: 585102; MetroCode: 0; Region: Karnataka; RegionCode: KA; Latitude: 17.3359; Longitude: 76.8341'
                if (!geoHeader) return null

                // Parse header: "Key: Value; Key2: Value2"
                return parseGeoString(geoHeader)
            } catch (error) {
                logger.error('customer context', {
                    namespace: 'hooks.useCustomCustomerContext',
                    additionalProperties: {error: error.message}
                })
            }
        },
        staleTime: 5 * 60000,
        cacheTime: 30 * 60000,
        enabled: Boolean(ip && usid)
    })

    return shopperContext
}

export default useCustomShopperContext
